import { useRecoilState } from "recoil";
import { recoilStates } from "src/recoil/recoilStates";
import Button from "../Button";
import styled from "styled-components";
import { digit4ToTimeString, setTime23_59_59, parseJsonStr, dateFormat } from "src/utils";
import { useNavigate, useLocation } from "react-router-dom";
import { useAlert } from "../../hooks";
import { useEffect, useState } from "react";
import STATIC_DATA from "src/staticData";
import AlertModal from "./components/common/AlertModal";
import guidePopupImage from "../../assets/images/guide_popup.png";
// import BaseRoundAccordion from "./components/common/BaseRoundAccordion";

export default function HasYearBookingContent() {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [showDepositModal, setShowDepositModal] = useState(false);
  const [group] = useRecoilState(recoilStates.group);
  const [user] = useRecoilState(recoilStates.user);
  const [bookingApplication] = useRecoilState(recoilStates.bookingApplication);
  const [expandedSchedules, setExpandedSchedules] = useState<{ [key: number]: boolean }>({});
  const clubRelData = bookingApplication?.clubRels?.find((cr) => {
    return [4, 6].includes(cr.year_booking_status_id);
  });
  const roundAsc = [...(clubRelData?.year_booking_round_dates ?? [])].sort((a, b) => {
    return new Date(a.round_date).getTime() - new Date(b.round_date).getTime();
  });
  const nextRound = roundAsc.find((round) => {
    return new Date(Date.now()) < setTime23_59_59(new Date(round.round_date));
  });
  const needDeposit = clubRelData?.round_deposit && clubRelData?.year_booking_status_id === 4;

  const myMemberData = group.members.find((m) => {
    return m.teeshot_user_id && m.teeshot_user_id === user.id;
  });
  const isGroupOfficer = [1, 2, 4].includes(myMemberData?.booking_group_member_level_id || 0);
  const myTeam = nextRound?.teams?.find((team) => {
    return team.year_booking_round_date_team_rel_booking_group_member?.some((mr) => {
      return mr.booking_group_member_id === myMemberData?.id;
    });
  });
  const myTeamMemberData = myTeam?.year_booking_round_date_team_rel_booking_group_member?.find(
    (mr) => {
      return mr.booking_group_member_id === myMemberData?.id;
    }
  );

  const navigate = useNavigate();
  const location = useLocation();
  const alert = useAlert();

  const toggleSchedule = (clubId: number) => {
    setExpandedSchedules((prev) => ({
      ...prev,
      [clubId]: !prev[clubId],
    }));
  };

  const step = (() => {
    if (needDeposit) {
      return "needDeposit";
    }
    if ((group.members?.length || 0) < 2) {
      return "mem";
    }
    if (!nextRound?.is_fixed) {
      return "team";
    }
    if (!nextRound?.is_paid) {
      return "pay";
    }
    return "fine";
  })();

  const [yearDepositNotied, setYearDepositNotied] = useRecoilState(recoilStates.yearDepositNotied);

  useEffect(() => {
    if (!needDeposit) {
      return;
    }

    if (yearDepositNotied) {
      return;
    }

    setShowDepositModal(true);
    // await alert.pause()
  }, [bookingApplication, yearDepositNotied]);

  useEffect(() => {
    if (location.pathname === "/year-booking") {
      const hasSeenModal = sessionStorage.getItem("yearBookingModalSeen");
      const previousPath = sessionStorage.getItem("previousPath");

      // 같은 세션에서 /year-booking/xxx 다녀왔다가 뒤로가기로 돌아온 경우
      if (previousPath && previousPath.startsWith("/year-booking/")) {
        setShowSuccessModal(false);
      } else if (!hasSeenModal) {
        // 최초 진입 또는 새로고침 → 모달 표시
        setShowSuccessModal(true);
      } else {
        // 이미 본 적 있음 → 모달 표시 안 함
        setShowSuccessModal(false);
      }
    }

    // 현재 경로를 이전 경로로 저장
    sessionStorage.setItem("previousPath", location.pathname);
  }, [location.pathname]);

  // 모달 닫기 핸들러
  const handleCloseModal = () => {
    setShowSuccessModal(false);
    sessionStorage.setItem("yearBookingModalSeen", "1"); // 닫을 때 기록
  };

  // 라운드 준비 절차 보기 클릭 핸들러
  const handleViewProcedure = () => {
    setShowSuccessModal(true);
  };

  const club = clubRelData?.club?.[0];
  const reservationAgent1Name = club?.reservationAgent1;
  const reservationAgent1Tel = club?.reservationAgentTel1;
  const reservePhone = club?.reserve_phone || club?.phone;
  const hasAgentData = reservationAgent1Name && reservationAgent1Tel;
  const hasPhone = Boolean(reservePhone);
  const etcRequirements = bookingApplication?.etcRequirements?.length
    ? bookingApplication?.etcRequirements
    : null;

  const isExpanded = expandedSchedules[clubRelData?.id || 0];

  // D-Day 계산 함수
  const calculateDDay = (targetDate: string) => {
    const today = new Date();
    const target = new Date(targetDate);

    // 시간 정보를 제거하고 날짜만 비교
    today.setHours(0, 0, 0, 0);
    target.setHours(0, 0, 0, 0);

    const diffTime = target.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) {
      return "D-DAY";
    } else if (diffDays > 0) {
      return `D-${diffDays}`;
    } else {
      return `D+${Math.abs(diffDays)}`;
    }
  };

  const dDayText = nextRound ? calculateDDay(nextRound.round_date) : null;

  return (
    <Container>
      {/* Main Content */}
      {/* <BaseRoundAccordion
        title="연 단체 이용 안내 및 문의"
        text="1. 멤버등록 → 2. 조 편성 제출 → 3. 라운드 확정 → 4. 락커번호 부여 → 5. 이용 수수료 납부"
        caption={[
          "멤버를 등록하고 조를 편성하면 라운드가 확정됩니다.\n골프장에서 부여하는 락커번호도 확인해주세요.\n\n☎ 문의가 필요한 경우 아래 연락처로 전화해주세요.\n티샷 연단체 문의: 02-2277-3489",
        ]}
      /> */}
      <BaseRoundBar>
        <div className="bar-header">
          <span className="bar-title">라운드 준비 절차</span>
          <span className="view-button" onClick={handleViewProcedure}>
            보기
          </span>
        </div>
      </BaseRoundBar>
      {showSuccessModal && (
        <GuideModal>
          <ModalOverlay onClick={handleCloseModal}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
              <GuideImage src={guidePopupImage} alt="연 단체 이용 안내" />
              <CloseButton onClick={handleCloseModal}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M18 6L6 18M6 6L18 18"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </CloseButton>
            </ModalContent>
          </ModalOverlay>
        </GuideModal>
      )}

      <div className="main-content">
        <div className="approval-header">
          <span className="approval-text">진행 중인 예약</span>
        </div>

        {/* Main Reservation Card */}
        {clubRelData && (
          <div className="reservation-card main-card">
            <div className="card-header">
              <h3 className="golf-course-name">
                다음 라운드까지
                {/* {dDayText && <span className="d-day-text">{dDayText}</span>} */}
              </h3>
              {/* <div className="status-badge approved">연간부킹</div> */}
              <div> {dDayText && <span className="d-day-text">{dDayText}</span>}</div>
            </div>

            <div className="card-info">
              <div className="info-row">
                <span className="info-label">일시</span>
                <span className="info-value">
                  {new Date(nextRound?.round_date ?? 0).toLocaleDateString("kr-KR", {
                    dateStyle: "full",
                  })}
                  {myTeam?.teeoff_time ? ` ${digit4ToTimeString(myTeam?.teeoff_time)}` : ""}
                </span>
              </div>
              <div className="info-row">
                <span className="info-label">클럽</span>
                <span className="info-value">{clubRelData.club?.[0]?.name}</span>
              </div>
              <div className="info-row">
                <span className="info-label">팀원</span>
                <span className="info-value">
                  {(() => {
                    const totalGroupMembers = group.members?.length || 0;
                    const otherMembers = totalGroupMembers - 1;
                    const teamCount =
                      nextRound?.teams?.filter(
                        (t) =>
                          (t.year_booking_round_date_team_rel_booking_group_member?.length ?? 0) > 0
                      )?.length || 0;

                    if (totalGroupMembers === 0) return "미정";

                    const memberText =
                      otherMembers > 0
                        ? `${myMemberData?.name || "본인"} 외 ${otherMembers}명`
                        : myMemberData?.name || "본인";

                    const teamText = teamCount > 0 ? ` (${teamCount}개 조)` : "";

                    return memberText + teamText;
                  })()}
                </span>
              </div>
              <div className="info-row">
                <span className="info-label">락커</span>
                <span
                  className="info-value"
                  style={{
                    color: myTeamMemberData?.locker_number ? "#1a1a1a" : "#007bff",
                  }}
                >
                  {myTeamMemberData?.locker_number ? myTeamMemberData?.locker_number : "*부여전"}
                </span>
              </div>
              {(clubRelData.round_deposit ?? 0) > 0 && (
                <div className="info-row">
                  <span className="info-label">보증금</span>
                  <span className="info-value">
                    {clubRelData.round_deposit?.toLocaleString()} 원
                  </span>
                </div>
              )}
              {(() => {
                const teamCount =
                  nextRound?.teams?.filter(
                    (t) =>
                      (t.year_booking_round_date_team_rel_booking_group_member?.length ?? 0) > 0
                  )?.length || 0;
                const fee = teamCount * 10000;

                if (fee > 0) {
                  return (
                    <div className="info-row">
                      <span className="info-label">수수료</span>
                      <span className="info-value">{fee.toLocaleString()} 원</span>
                    </div>
                  );
                }
                return null;
              })()}
              {(clubRelData.meal_price_per_person ?? 0) > 0 && (
                <div className="info-row">
                  <span className="info-label">객단가</span>
                  <span className="info-value">
                    {clubRelData.meal_price_per_person?.toLocaleString()} 원
                  </span>
                </div>
              )}
              {(nextRound?.green_fee ?? 0) > 0 && (
                <div className="info-row">
                  <span className="info-label">
                    그린피 <span className="golf-course-note-inline">*골프장 상황에 따라 변동</span>
                  </span>
                  <span className="info-value">{nextRound?.green_fee?.toLocaleString()} 원</span>
                </div>
              )}
            </div>

            <div className="schedule-details">
              <div className="schedule-header" onClick={() => toggleSchedule(clubRelData.id || 0)}>
                <span className="schedule-title">일정 및 그린피 정보</span>
                <svg
                  width="10"
                  height="7"
                  viewBox="0 0 10 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className={`chevron-icon ${isExpanded ? "expanded" : ""}`}
                >
                  <path
                    d={
                      isExpanded
                        ? "M5 2.47226L1.78151 5.86956C1.44745 6.22217 0.885883 6.22217 0.551825 5.86956C0.242354 5.54289 0.242354 5.03126 0.551825 4.70459L4.49875 0.538393C4.77109 0.250921 5.22891 0.250921 5.50125 0.538393L9.44818 4.70459C9.75765 5.03126 9.75765 5.54289 9.44818 5.86956C9.11412 6.22217 8.55255 6.22217 8.21849 5.86956L5 2.47226Z"
                        : "M5 4.52774L8.21849 1.13044C8.55255 0.77783 9.11412 0.77783 9.44818 1.13044C9.75765 1.45711 9.75765 1.96874 9.44818 2.29541L5.50125 6.46161C5.22891 6.74908 4.77109 6.74908 4.49875 6.46161L0.551825 2.29541C0.242354 1.96874 0.242354 1.45711 0.551825 1.13044C0.885883 0.77783 1.44745 0.77783 1.78151 1.13044L5 4.52774Z"
                    }
                    fill="#79818A"
                  />
                </svg>
              </div>

              {isExpanded && (
                <div className="schedule-info">
                  <div className="schedule-section">
                    <div className="facility-section">
                      <h4 className="section-title">라운드 일시</h4>
                      <p className="section-content">
                        <span style={{ fontWeight: 700 }}>
                          {JSON.parse(clubRelData?.week_arr_json_str || "[]")?.join("주차, ")}주
                          {" " + JSON.parse(clubRelData?.day_arr_json_str || "[]")?.join("요일")}
                          요일 {clubRelData?.start_time?.slice(0, 2)}:
                          {clubRelData?.start_time?.slice(2, 4)}
                        </span>
                      </p>
                      <MonthButtonContainer>
                        {(() => {
                          const months = parseJsonStr(clubRelData?.month_arr_json_str ?? "[]");
                          if (!months || months.length === 0) return <div> - </div>;
                          return months
                            .map((num: any) => +num)
                            .sort((a: number, b: number) => a - b)
                            .map((m: number) => <MonthButton key={m}>{m}월</MonthButton>);
                        })()}
                      </MonthButtonContainer>
                    </div>
                  </div>

                  <div className="facility-section">
                    <div className="round-details">
                      {clubRelData.year_booking_round_dates?.map((rd: any, roundIdx: number) => (
                        <div key={`round-${roundIdx}`} className="round-item">
                          <h5 className="round-date">
                            {dateFormat(new Date(rd.round_date)) +
                              " " +
                              clubRelData?.start_time?.slice(0, 2)}
                            :{clubRelData?.start_time?.slice(2, 4)}{" "}
                          </h5>
                          <div className="round-pricing">
                            <div className="pricing-row">
                              <span className="pricing-label">그린피</span>
                              <span className="pricing-value">
                                {rd.green_fee?.toLocaleString()} 원
                              </span>
                            </div>
                            <div className="pricing-row">
                              <span className="pricing-label">카트피</span>
                              <span className="pricing-value">
                                {rd.cart_fee?.toLocaleString()} 원
                              </span>
                            </div>
                            <div className="pricing-row">
                              <span className="pricing-label">캐디피</span>
                              <span className="pricing-value">
                                {rd.caddy_fee?.toLocaleString()} 원
                              </span>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="facility-section">
                    <h4 className="section-title">시설이용</h4>
                    <div className="facility-info">
                      <div className="facility-row">
                        <span className="facility-label">결제방식</span>
                        <span className="facility-value">
                          {STATIC_DATA.PAY_TYPE_DATA.find(
                            (d) => d.id === bookingApplication?.payment_type_id
                          )?.name || " - "}
                        </span>
                      </div>
                      <div className="facility-row">
                        <span className="facility-label">식사 선택</span>
                        <span className="facility-value">
                          {STATIC_DATA.MEAL_TYPE_DATA.find(
                            (d) => d.id === bookingApplication?.meal_type_id
                          )?.name || " - "}
                        </span>
                      </div>
                      <div className="facility-row">
                        <span className="facility-label">프로샵 이용</span>
                        <span className="facility-value">
                          {bookingApplication?.proshop_item || " - "}
                        </span>
                      </div>
                      <div className="facility-row">
                        <span className="facility-label">룸 이용</span>
                        <span className="facility-value">
                          {(() => {
                            const roomTypeId =
                              clubRelData?.year_booking_round_dates?.[0]?.room_type_id;
                            if (roomTypeId === null || roomTypeId === undefined) return " - ";
                            return roomTypeId === 1
                              ? "라운드 전"
                              : roomTypeId === 2
                              ? "라운드 후"
                              : " - ";
                          })()}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="game-section">
                    <h4 className="section-title">경기 및 시상</h4>
                    <div className="game-info">
                      <div className="game-row">
                        <span className="game-label">경기방식</span>
                        <span className="game-value">
                          {
                            STATIC_DATA.GAME_TYPE_DATA.find((d) => {
                              return d.id === bookingApplication?.game_type_id;
                            })?.name
                          }
                        </span>
                      </div>
                      <div className="game-row">
                        <span className="game-label">티 사용</span>
                        <span className="game-value">
                          {
                            STATIC_DATA.TEEBOX_TYPE_DATA.find((d) => {
                              return d.id === bookingApplication?.teebox_type_id;
                            })?.name
                          }
                        </span>
                      </div>
                      <div className="game-row">
                        <span className="game-label">시상내용</span>
                        <span className="game-value">
                          {(() => {
                            const awardIds = parseJsonStr(
                              bookingApplication?.award_ids_arr_json_str ?? ""
                            );
                            const hasAwards = awardIds && awardIds.length > 0;
                            if (hasAwards) {
                              const awards = STATIC_DATA.AWARDS_DATA.filter((d) => {
                                return awardIds.includes(d.id);
                              });
                              return awards
                                ?.map((a) => {
                                  return a.name;
                                })
                                .join(", ");
                            }
                            return " - ";
                          })()}
                        </span>
                      </div>
                      <div className="game-row">
                        <span className="game-label">요청사항</span>
                        <span className="game-value">
                          {etcRequirements ? etcRequirements.map((e) => e.name)?.join(", ") : " - "}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="notice-section">
                    <h4 className="section-title">안내사항</h4>
                    <p className="notice-content">{clubRelData?.etc_notification || " - "}</p>
                  </div>

                  <div className="contact-section">
                    <p className="contact-info">
                      {(() => {
                        if (hasAgentData) {
                          return `예약담당자 ${reservationAgent1Name}: ${reservationAgent1Tel}`;
                        }
                        if (hasPhone) {
                          return `예약연락처: ${reservePhone}`;
                        }
                        return "티샷: 02-2277-3489";
                      })()}
                    </p>
                    <p className="disclaimer">
                      *상기 비용은 골프장의 상황에 따라 변경될 수 있고, 문의가 필요한 경우 전화로
                      협의해 주시기 바랍니다.
                    </p>
                  </div>
                </div>
              )}
            </div>
            {/* Team Management Button */}
            <div className="button-Box">
              {isGroupOfficer &&
                (group.members.length >= 3 ? (
                  <Button
                    style={{ fontSize: "14px" }}
                    className="team-button"
                    $colorTheme="green"
                    $buttonSize="md"
                    disabled={!isGroupOfficer}
                    $round
                    onClick={() => {
                      navigate("/year-booking/team-register");
                      // navigate("/year-booking");
                    }}
                  >
                    조 편성
                  </Button>
                ) : (
                  <Button
                    style={{ fontSize: "14px" }}
                    className="team-button"
                    $colorTheme="green"
                    $buttonSize="md"
                    disabled={!isGroupOfficer}
                    $round
                    onClick={() => {
                      navigate("/year-booking/group-members/list");
                    }}
                  >
                    멤버등록
                  </Button>
                ))}

              {/* Payment Button */}
              {isGroupOfficer && nextRound && !nextRound.is_paid && nextRound.is_fixed === 1 && (
                <Button
                  style={{ fontSize: "14px" }}
                  className="payment-button"
                  $colorTheme="green"
                  $buttonSize="md"
                  disabled={!isGroupOfficer}
                  $round
                  onClick={() => {
                    navigate("/year-booking/roundPayment");
                  }}
                >
                  수수료 납부
                </Button>
              )}
            </div>
          </div>
        )}

        {/* No Next Round */}
        {!nextRound && (
          <div className="reservation-card status-card">
            <div className="card-header">
              <h3 className="golf-course-name">다음 라운드</h3>
              <div className="status-badge unavailable">예정 없음</div>
            </div>
            <p className="status-message">다음 라운드 예정일이 없습니다.</p>
            <div className="card-info">
              <Button
                $colorTheme="green"
                onClick={() => {
                  setShowAlertModal(true);
                }}
              >
                새로운 부킹 신청하기
              </Button>
            </div>
          </div>
        )}

        {/* Contact Information */}
        {/* <div className="contact-info-section">
          <p>연간 부킹관련 문의</p>
          <p>티샷: 02-2277-3489</p>
        </div> */}
      </div>

      {/* Alert Modal */}
      {showAlertModal && (
        <AlertModal
          title="새로운 부킹 신청"
          subtitle="전화문의: 02-2277-3489"
          lines={["계약 만료처리 요청해주세요."]}
          confirmText="확인"
          onClose={() => setShowAlertModal(false)}
          onConfirm={() => setShowAlertModal(false)}
        />
      )}

      {/* Deposit Modal */}
      {showDepositModal && (
        <AlertModal
          title="보증금 입금안내"
          subtitle="보증금을 결제해 주시기 바랍니다."
          confirmText="확인"
          onClose={() => {
            setShowDepositModal(false);
            setYearDepositNotied(1);
            navigate("/year-booking/deposit");
          }}
          onConfirm={() => {
            setShowDepositModal(false);
            setYearDepositNotied(1);
            navigate("/year-booking/deposit");
          }}
        />
      )}
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  min-height: 314px;
  background: #fdfdfd;
  font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
  position: relative;
  margin: 0 auto;

  /* Main Content */
  .main-content {
    padding: 0 16px 24px;
  }

  .approval-header {
    margin: 4px;
    margin-top: 10px;
  }

  .approval-text {
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
  }

  /* Reservation Cards */
  .reservation-card {
    border: 0.5px solid #d1d5d8;
    border-radius: 6px;
    background: #fdfdfd;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.5);
    margin-bottom: 16px;
  }

  .card-header {
    padding: 11px 16px;
    border-bottom: 0.5px solid #d1d5d8;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .golf-course-name {
    color: #1a1a1a;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .d-day-text {
    color: #f97000; /* Teeshot Secondary Color/Teeshot Yellow */
    font-size: 14px;
    font-weight: 700;
  }

  .status-badge {
    padding: 4px 6px;
    border-radius: 3px;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
  }

  .status-badge.approved {
    background: #e1f4f3;
    color: #004b49;
  }

  .status-badge.reviewing {
    background: #79818a;
    color: #fdfdfd;
  }

  .status-badge.unavailable {
    background: #d1d5d8;
    color: #fdfdfd;
  }

  .card-info {
    padding: 16px;
  }

  .info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }

  .info-label {
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
  }

  .info-value {
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
  }

  .golf-course-note {
    color: #79818a;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    margin-top: 16px;
  }

  .golf-course-note-inline {
    color: #79818a;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
  }

  /* Schedule Details */
  .schedule-details {
    background: #f0f0f4;
    border-radius: 6px;
    margin: 16px;
  }

  .schedule-header {
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }

  .chevron-icon {
    /* 회전 애니메이션 제거 - SVG 경로로 직접 제어 */
  }

  .schedule-title {
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
  }

  .schedule-info {
    padding: 10px;
    border-top: 0.5px solid #d1d5d8;
  }

  .schedule-section {
    margin-bottom: 24px;
  }

  .section-title {
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    margin: 0 0 8px 0;
  }

  .section-content {
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    margin: 4px 0;
  }

  .round-details {
    margin-bottom: 24px;
  }

  .round-item {
    margin-bottom: 24px;
    padding-bottom: 24px;
    border-bottom: 0.5px solid #d1d5d8;
  }

  .round-item:last-child {
    border-bottom: none;
  }

  .round-date {
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    margin: 0 0 12px 0;
  }

  .round-pricing {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .pricing-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .pricing-label {
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
  }

  .pricing-value {
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
  }

  .facility-section,
  .game-section {
    margin-bottom: 24px;
    padding-bottom: 24px;
    border-bottom: 0.5px solid #d1d5d8;
  }

  .facility-info,
  .game-info {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 12px;
  }

  .facility-row,
  .game-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .facility-label,
  .game-label {
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
  }

  .facility-value,
  .game-value {
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
  }

  .notice-section {
    margin-bottom: 24px;
  }

  .notice-content {
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    margin: 8px 0;
  }

  .contact-section {
    margin-top: 24px;
  }

  .contact-info {
    color: #007bff;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    margin: 0 0 12px 0;
  }

  .disclaimer {
    color: #79818a;
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    margin: 0;
  }

  /* Status Cards */
  .status-card {
    padding-bottom: 16px;
  }

  .status-message {
    color: #79818a;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    padding: 0 16px;
    margin: 8px 0 0 0;
  }

  .contact-info-section {
    text-align: center;
    margin: 24px 0;
    p {
      margin: 4px 0;
      color: #1a1a1a;
      font-size: 14px;
      font-weight: 500;
    }
  }

  .payment-button {
    width: 100%;
    margin-bottom: 8px;
  }

  .team-button {
    width: 100%;
    margin-top: 8px;
    margin-bottom: 8px;
  }
  .button-Box {
    width: 100%;
    margin: 0 auto;
    padding: 0 16px;
  }
`;

const GuideModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
`;

const ModalContent = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 90vw;
  max-height: 90vh;
`;

const GuideImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 8px;
`;

const CloseButton = styled.button`
  position: absolute;
  top: -40px;
  right: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.6);
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    background: rgba(0, 0, 0, 0.8);
  }
`;

const MonthButtonContainer = styled.div`
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
`;

const MonthButton = styled.div`
  display: flex;
  padding: 4px 6px;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  color: #fff;
  background-color: #000000;
  border-radius: 6px;
`;

const BaseRoundBar = styled.div`
  background-color: #f0f0f4;
  border-radius: 6px;
  padding: 16px;
  margin: 16px;
  color: #79818a;

  .bar-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .bar-title {
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
  }

  .view-button {
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    text-decoration: underline;
    cursor: pointer;
    color: #79818a;

    &:hover {
      color: #333;
    }
  }
`;
